import client from '/src/services/client.js';

export default {
    changeMyPassword: (data) => client.put('administration/user/me/password', data),
    getMyActivity: (data) => client.get('administration/logs/me', data),
}
